const adminEmails = [
  'tom@tophouse.com',
  'vlad@tophouse.com',
  'ben@tophouse.com',
];

export { adminEmails };
